/*
* @Author: Abhi Bhatt
* @Date:   2020-07-09 14:43:38
* @Last Modified by:   abhi
* @Last Modified time: 2021-05-04 16:52:48
*/
// import React from 'react';
// import {Redirect,Route} from 'react-router-dom';

// class ProtectedRoute extends React.Component
// {
// 	render() {
//     const { component: Component, ...props } = this.props
//     let session_id = localStorage.getItem('techtop_user_id');
//     return (
//       <Route 
//         {...props} 
//         render={props => (
//           typeof session_id !== "undefined" && session_id !== null && session_id !== '' ?
//             <Component {...props} /> :
//             <Redirect to='/' />
//         )} 
//       />
//     )
//   }
// }

// export default ProtectedRoute;

import React from 'react';
import { Redirect, Route } from 'react-router-dom';

class ProtectedRoute extends React.Component {
  render() {
    const { component: Component, ...props } = this.props;
    const session_id = localStorage.getItem('techtop_user_id');

    return (
      <Route
        {...props}
        render={(routeProps) => {
          const isLoggedIn =
            session_id !== undefined &&
            session_id !== null &&
            session_id !== '';

          // If user is logged in → allow access
          if (isLoggedIn) {
            return <Component {...routeProps} />;
          }

          // If NOT logged in and trying to access /track-shipment
          if (routeProps.location.pathname === '/track-shipment') {
            return <Redirect to="/user/sign-up" />;
          }

          // Default redirect
          return <Redirect to="/" />;
        }}
      />
    );
  }
}

export default ProtectedRoute;